import {
  Button,
  Card,
  Col,
  List,
  message,
  Row,
  Space,
  Spin,
  Typography,
  Select,
  Tag,
  Modal,
} from "antd";
import React, { useEffect, useState } from "react";
import Get from "../services/Get";
import { useNavigate, useParams } from "react-router-dom";
import Post from "../services/Post";

const { Option } = Select;
const { Text, Title } = Typography;

const MlmIncome = () => {
  const [loading, setLoading] = useState(false);
  const [showTotalModal, setShowTotalModal] = useState(false);
  const [levelTotal, setLevelTotal] = useState(0);
  const [incomes, setIncomes] = useState([]);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedLevel, setSelectedLevel] = useState("All");
  const [levels, setLevels] = useState(["All", "Direct"]);
  const [selectedRank, setSelectedRank] = useState();

  const navigate = useNavigate();
  const { type } = useParams();

  const getData = async (page = 1, level = "", rank = "") => {
    setLoading(true);
    try {
      const res = await Get.MLMIncome(page, level, type, rank);
      if (res.error) {
        message.error(res.error);
      } else {
        const maxLevel = res.maxLevel || 2;
        const generatedLevels = Array.from({ length: maxLevel - 1 }, (_, i) =>
          (i + 2).toString()
        );
        setLevels(["All", "Direct", ...generatedLevels]);
        setIncomes(res.data.data); // data from pagination
        setTotal(res.data.total); // total count
      }
    } catch (error) {
      message.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleGoBack = () => {
    if (selectedLevel == "All" && !selectedRank) {
      navigate("/user/affiliate-program");
    } else {
      setSelectedLevel("All");
      setSelectedRank();
      getData();
    }
  };

  const getRankTag = (rank) => {
    if (rank === "creator") return <Tag color="cyan">Creator</Tag>;
    if (rank === "star" || rank == 1) return <Tag color="blue">Star</Tag>;
    if (rank === "silver") return <Tag color="green">Silver</Tag>;
    if (rank === "gold") return <Tag color="gold">Gold</Tag>;
    if (rank === "platinum") return <Tag color="grey">Platinum</Tag>;
    if (rank === "diamond") return <Tag color="red">Diamond</Tag>;
  };

  const handleWithdraw = async (id) => {
    setLoading(true);
    try {
      const data = {
        event_id: id,
      };
      console.log(data);
      const res = await Post.WithdrawMlmIncome(data);
      console.log("Response == ", res);

      if (res) {
        if (res.error) {
          console.log(res.error);
          message.error(res.error);
        } else {
          console.log("Success!");
          message.success(res.message);
        }
      }
    } catch (error) {
      message.error(error);
    } finally {
      getData();
      setLoading(false);
    }
  };

  const calculateTotal = async (level) => {
    setLoading(true);
    try {
      const res = await Get.MLMLevelCalculate(level, type);
      if (res.error) {
        message.error(res.error);
      } else {
        setLevelTotal(res.total);
        setShowTotalModal(true);
      }
    } catch (error) {
      message.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleWithdrawAll = async () => {
    setLoading(true);
    try {
      const data = {
        level: selectedLevel == "Direct" ? 1 : selectedLevel,
        type: type,
      };
      console.log(data);
      const res = await Post.WithdrawMlmLevelIncome(data);
      console.log("Response == ", res);

      if (res) {
        if (res.error) {
          console.log(res.error);
          message.error(res.error);
        } else {
          console.log("Success!");
          message.success(res.message);
        }
      }
    } catch (error) {
      message.error(error);
    } finally {
      getData();
      setShowTotalModal(false);
      setTotal(0);
      setLoading(false);
    }
  };

  useEffect(() => {
    getData(currentPage, selectedLevel, selectedRank);
  }, [currentPage, selectedLevel, selectedRank]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Helper to display levels with better formatting
  const getLevelTag = (level) => {
    if (level === "Direct") return <Tag color="green">Direct</Tag>;
    if (level === "All") return <Tag color="green">All Levels</Tag>;
    return <Tag color="purple">Level {level}</Tag>;
  };

  return (
    <div className="layout-content">
      <Row gutter={[24, 24]} justify="center">
        <Col xs={24} md={20}>
          {loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "80vh",
              }}
            >
              <Spin size="large" />
            </div>
          ) : (
            <Space
              direction="vertical"
              size="middle"
              style={{ display: "flex", marginBottom: 20 }}
            >
              {/* Header Section */}
              <Row
                justify="space-between"
                align="middle"
                style={{ marginLeft: "0px", marginRight: "0px" }}
              >
                <Button
                  className="form-btn"
                  onClick={handleGoBack}
                  // onClick={() => navigate("/user/affiliate-program")}
                >
                  Go Back
                </Button>

                {type !== "royality" && (
                  <Space>
                    <Select
                      placeholder="Select Level"
                      style={{ width: 150 }}
                      value={selectedLevel}
                      onChange={setSelectedLevel}
                    >
                      {levels.map((level) => (
                        <Option key={level} value={level}>
                          {getLevelTag(level)}
                        </Option>
                      ))}
                    </Select>
                    {selectedLevel !== "All" && (
                      <Button
                        type="primary"
                        onClick={() =>
                          calculateTotal(
                            selectedLevel == "Direct" ? 1 : selectedLevel
                          )
                        }
                        className="form-btn"
                      >
                        Withdraw All
                      </Button>
                    )}
                  </Space>
                )}
                {(type == "leadership" || type == "royality") && (
                  <Space>
                    <Select
                      placeholder="Select Rank"
                      style={{ width: 150, marginTop: "10px" }}
                      value={selectedRank}
                      onChange={setSelectedRank}
                    >
                      <Option key={"star"} value={"star"}>
                        {getRankTag("star")}
                      </Option>
                      <Option key={"silver"} value={"silver"}>
                        {getRankTag("silver")}
                      </Option>
                      <Option key={"gold"} value={"gold"}>
                        {getRankTag("gold")}
                      </Option>
                      <Option key={"platinum"} value={"platinum"}>
                        {getRankTag("platinum")}
                      </Option>
                      <Option key={"diamond"} value={"diamond"}>
                        {getRankTag("diamond")}
                      </Option>
                    </Select>
                  </Space>
                )}
              </Row>

              {/* Incomes List */}
              <Card>
                <List
                  className="income_list"
                  header={<Title level={4}>Incomes</Title>}
                  bordered
                  dataSource={incomes}
                  renderItem={(item) => (
                    <List.Item
                      actions={[
                        <Button
                          type="primary"
                          className="form-btn"
                          disabled={item.withdrawed == "true"}
                          onClick={() => handleWithdraw(item.id)}
                        >
                          {item.withdrawed == "true"
                            ? "Already Withdrawed"
                            : "Withdraw Amount"}
                        </Button>,
                      ]}
                    >
                      <List.Item.Meta
                        title={
                          <>
                            {type == "leadership" &&
                              item.rank !== null &&
                              getRankTag(item.rank)}{" "}
                            {type !== "royality" ? (
                              <>
                                {getLevelTag(item.level)} {item.from_user ?? ""}
                              </>
                            ) : (
                              getRankTag(item.rank)
                            )}
                          </>
                        }
                        description={
                          <>
                            <Text
                              strong
                              style={{ color: "#52c41a", fontSize: "16px" }}
                            >
                              ₹{item.price.toFixed(2)}
                            </Text>
                          </>
                        }
                      />
                    </List.Item>
                  )}
                  pagination={{
                    current: currentPage,
                    total: total,
                    pageSize: 10,
                    onChange: handlePageChange,
                    showSizeChanger: false,
                  }}
                />
              </Card>

              <Modal
                title="Total Level Income"
                open={showTotalModal}
                onCancel={() => setShowTotalModal(false)}
                footer={[
                  <Button key="cancel" onClick={() => setShowTotalModal(false)}>
                    Cancel
                  </Button>,
                  <Button
                    key="withdraw"
                    type="primary"
                    onClick={handleWithdrawAll}
                    className="form-btn"
                  >
                    Withdraw
                  </Button>,
                ]}
              >
                <Text strong>
                  Total Level {selectedLevel} Income: ₹{levelTotal.toFixed(2)}
                </Text>
              </Modal>
            </Space>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default MlmIncome;
